import { AppShell } from "@theg1group/app-shell";
import { PagesRegistryProvider, type RegistryPage } from "@theg1group/rbac-ui";
import { ScanSearch } from "lucide-react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AUTH_URL } from "./config.ts";
import { AuthProvider } from "./lib/auth.tsx";
import { emailnetworkNav } from "./nav.ts";
import { CaseView } from "./pages/Case.tsx";
import { DomainView } from "./pages/Domain.tsx";
import { Brands } from "./pages/Brands.tsx";
import { Files } from "./pages/Files.tsx";
import { GraphPage } from "./pages/Graph.tsx";
import { Mailboxes } from "./pages/Mailboxes.tsx";
import { MessageDetail } from "./pages/MessageDetail.tsx";
import { Monitor } from "./pages/Monitor.tsx";
import { Overview } from "./pages/Overview.tsx";
import { Timeline } from "./pages/Timeline.tsx";

async function fetchPagesRegistry(): Promise<{ data: RegistryPage[] }> {
	const res = await fetch(`${AUTH_URL}/pages-registry`, { credentials: "include" });
	if (!res.ok) throw new Error(`pages-registry ${res.status}`);
	return (await res.json()) as { data: RegistryPage[] };
}

export function App() {
	return (
		<AuthProvider>
			<PagesRegistryProvider appId="emailnetwork" fetchRegistry={fetchPagesRegistry}>
				<AppShell
					appId="emailnetwork"
					authUrl={AUTH_URL}
					features={[emailnetworkNav]}
					branding={{ title: "Email Network", Icon: ScanSearch }}
					requireAppAccess="emailnetwork"
					require2FA={false}
				>
					<Routes>
						<Route path="/overview" element={<Overview />} />
						<Route path="/files" element={<Files />} />
						<Route path="/messages/:id" element={<MessageDetail />} />
						<Route path="/domains/:name" element={<DomainView />} />
						<Route path="/graph" element={<GraphPage />} />
						<Route path="/brands" element={<Brands />} />
						<Route path="/brands/:domain" element={<Brands />} />
						<Route path="/timeline" element={<Timeline />} />
						<Route path="/cases" element={<CaseView />} />
						<Route path="/cases/:id" element={<CaseView />} />
						<Route path="/mailboxes" element={<Mailboxes />} />
						<Route path="/monitor" element={<Monitor />} />
						<Route path="*" element={<Navigate to="/overview" replace />} />
					</Routes>
				</AppShell>
			</PagesRegistryProvider>
		</AuthProvider>
	);
}
